import {Set, Map} from 'immutable';

import {
  SET_ORGANIZATION,
  SET_ORGANIZATIONS,
  SET_ORGANIZATIONS_SUMMARY,
  RESET_ORGANIZATION,
} from '../actions';

const server = (state = Map({organizationIDs: Set(), organizationsMap: Map(), organizationsSummary: Map()}), action) => {
  let newState = state;

  switch (action.type) {
    case SET_ORGANIZATIONS:
      for (let i = 0; i < action.payload.organizations.length; i += 1){
        newState = newState.setIn(['organizationsMap', action.payload.organizations[i]._id], action.payload.organizations[i]);
        newState = newState.setIn(['organizationIDs'],
                    newState.getIn(['organizationIDs']).add(action.payload.organizations[i]._id));
      }
      return newState;
    case SET_ORGANIZATIONS_SUMMARY:
      for (let s of action.payload.organizationSummary) {
        newState = newState.setIn(['organizationsSummary', s._id.abbreviation], s);
      }
      return newState;
    case SET_ORGANIZATION:
      return newState.setIn(['organizationsMap', action.payload.organization._id], action.payload.organization);
    case RESET_ORGANIZATION:
      return newState.deleteIn(['organizationsMap', action.payload.organizationId]);
    default:
      return newState;
  }
}

export default server;


// WEBPACK FOOTER //
// ./src/organizations/reducers/server.js